import type { ReactNode } from 'react';

export const symbol_y_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M455-408v144q0 10.61 7 17.8 7 7.2 18 7.2t18-7.2q7-7.19 7-17.8v-146l124-227q6-11 2-19t-12-13q-8-5-17.5-3T587-659L480-455 373-659q-5-11-14.48-13t-17.5 3Q333-664 329-655.5t2 19.5l124 228ZM324-111.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5ZM479.51-140q141.52 0 241-99Q820-338 820-479.51q0-141.52-99.49-241-99.48-99.49-241-99.49Q338-820 239-720.51q-99 99.48-99 241Q140-338 239-239t240.51 99Zm.49-340Z"
		/>
	</svg>
);
